import React, { Component, Fragment } from "react"
import { Spin, Button } from "antd"
import facebookIcon from "../../../images/facebook.svg"
import linkedinIcon from "../../../images/linkedin.svg"
import manduIconConfig from "../../../images/mandu-config.svg"

class Preview extends Component {
  state = { loadingImage: true }

  render() {
    return (
      <Fragment>
        <div className="measurement-mail-configuration-content">
          {this.props.logoUrl.pathImage && (
            <div className="measurement-mail-configuration-content-logo">
              <img src={this.props.logoUrl.pathImage} />
            </div>
          )}
          <Spin
            spinning={
              this.props.loadImageIntern ||
              this.props.isLoadingImageUrl ||
              this.state.loadingImage
            }
            style={{
              backgroundColor: "#FFF",
              // maxHeight: this.props.imageHeight + 28,
              textAlign: "center",
            }}
            size="large">
            {this.props.imageUrl && (
              <div className="measurement-mail-configuration-content-image">
                <img
                  onLoad={() => this.setState({ loadingImage: false })}
                  src={
                    this.props.imageUrl.pathImage
                      ? this.props.imageUrl.pathImage.img ||
                        this.props.imageUrl.pathImageOld.img
                      : ""
                  }
                  style={{
                    width: this.props.imageWidth,
                    height: this.props.imageHeight,
                  }}
                />
              </div>
            )}
          </Spin>
          {this.props.isEmptyTextBody && (
            <div
              className="ql-editor measurement-mail-configuration-content-text"
              dangerouslySetInnerHTML={{ __html: this.props.email_text }}
            />
          )}
          <div className="measurement-mail-configuration-content-action">
            <Button
              type="primary"
              style={{ backgroundColor: this.props.email_background_button }}>
              {this.props.email_button_text}
            </Button>
          </div>
        </div>
        <div className="measurement-mail-configuration-footer">
          <div>
            <a
              href="https://www.facebook.com/manduhr"
              target="_blink"
              style={{ marginRight: 12 }}>
              <img src={facebookIcon} />
            </a>
            <a
              href="https://www.linkedin.com/company/mand%C3%BC/"
              target="_blink">
              <img src={linkedinIcon} />
            </a>
          </div>
          <div>
            <p>
              Desarollado por{" "}
              <a
                style={{ fontWeight: 500 }}
                href="https://mandu.pe/"
                target="_blink">
                Mandü.
              </a>
            </p>
            <p>
              Copyright {new Date().getFullYear()} - Mandü. Todos los derechos
              reservados Lima, Perú.
            </p>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default Preview
